import script from "./bootstrap-datepicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./bootstrap-datepicker.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__